module.exports = __webpack_public_path__ + "img/info.17de794e.svg";